import React from 'react';

export default class Page7 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToDevelopRapport');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div
                                                className="lightgreencontentbg keyquestionpad lightbgcontentShrink uiheading">
                                                <p>When you try something new you may feel a bit clumsy because
                                                    it feels unfamiliar, even though you’d probably do it
                                                    unconsciously with someone close. As with anything, though,
                                                    practising will help to make it easier and increase your
                                                    confidence.</p>
                                            </div>
                                            <br/>
                                                <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                    <span className="heading">TAKE AWAY MESSAGES</span>
                                                </div>
                                                <p>There are three things of particular importance to keep in
                                                    mind:</p>
                                                <ol className="brownbullet-list listcontentSpacing">
                                                    <li><p>Building rapport requires some thought and effort,
                                                        even for those of us who are ‘naturally’ skilled in this
                                                        area. Think about the first impression you’re planning
                                                        to make with the person you’re about to meet. </p></li>
                                                    <li><p>‘Pacing’ the words, phrases, images and, to some
                                                        extent, the beliefs and opinions of the person you wish
                                                        to build rapport with enhances communication.</p></li>
                                                    <li><p> ‘Mirroring’ the body language of the person you’re
                                                        speaking to often happens naturally. Being mindful of
                                                        using it as a tool will help build rapport more easily
                                                        with people you don’t know very well.</p></li>
                                                </ol>

                                                <div
                                                    className="lightgreencontentbg keyquestionpad lightbgcontentShrink">
                                                    <div className="border_subtitle">Create and improve
                                                        relationships
                                                    </div>
                                                    <p>Everyone can learn to build rapport; done well this can
                                                        have a hugely positive impact on developing and
                                                        maintaining excellent working relationships.</p>

                                                </div>
                                                <br/>
                                                    <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                        <span className="heading">Further Information</span>
                                                    </div>
                                                    <div className="paraspace"><p>If you found this tool useful
                                                        then you are likely to find the following tools both
                                                        insightful and relevant:</p></div>
                                                    <div className="keyquestionpad">
                                                        <ul className="greenbullet-list">
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToCommunicateEffectively')}>How
                                                                to communicate effectively</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToManageYourImpact')}>How
                                                                to manage your impact</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToBuildAndMaintainTrust')}>How
                                                                to build and maintain trust</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToActivelyListen')}>How
                                                                to actively listen.</div></li>

                                                        </ul>
                                                    </div>
                                                    <div className="circle_title referencepad"><img
                                                        src={require('@images/browndot.jpg')}
                                                        alt=""/>REFERENCES</div>

                                                    <ol className="testclass">
                                                        <li><p className="further_info_content">Willis,
                                                            J. &amp; Todorov, A. (2006). First impressions:
                                                            Making up your mind after a 100-ms exposure to a
                                                            face.<span
                                                                className="subtiltereg"> Psychological Science</span>,
                                                            17, 592-598.</p></li>
                                                        <li><p className="further_info_content">Asch, S. (1946).
                                                            Forming impressions of personality. <span
                                                                className="subtiltereg">Journal of Abnormal and Social Psychology</span>,
                                                            41, 258-290.</p></li>
                                                        <li><p className="further_info_content">Mehrabian, A.
                                                            (1981). <span className="subtiltereg">Silent messages: Implicit communication of emotions and attitudes (2nd ed.).</span> Wadsworth,
                                                            Belmont, California.</p></li>
                                                        <li><p className="further_info_content">Hollman,
                                                            W.  &amp;  Kleiner, B. (1997). Establishing rapport:
                                                            the secret business tool to success.<span
                                                                className="subtiltereg"> Managing Service Quality</span>,
                                                            7, 4, 194-197.</p></li>
                                                        <li><p className="further_info_content">Erickson, J.
                                                            (2004). <span className="subtiltereg">The Art of Persuasion: How to Influence People and Get What you Want.</span> Hodder
                                                            Mobius, St Ives.</p></li>
                                                    </ol>

                                                    <div className="left-btn">
                                                        <div
                                                            onClick={this.props.handleChangePage('Page6')}
                                                            className="button-next-previous-done">&lt;&lt; Previous
                                                        </div>
                                                    </div>
                                                    <div className="right-btn">
                                                        <div
                                                            onClick={this._savePageStatus('People')}
                                                            className="button-next-previous-done">Done
                                                        </div>
                                                    </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }